/* eslint-disable max-len */
import { createFeature, createReducer, on } from '@ngrx/store';
import * as luxon from 'luxon';
import * as actions from './inf-change-depot.actions';

export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    receivedTime: null,
};

export default createFeature({
    name: 'infChangeDepot',
    reducer: createReducer(
        initialState,
        on(actions.error, (state: State, { error }): State => ({
            ...state,
            error: error?.message || 'Error',
            loaded: false,
            loading: false,
        })),
        on(actions.reset, (state: State): State => ({
            ...state,
            error: null,
            loaded: false,
            loading: false,
            receivedTime: null,
        })),
        on(actions.received, (state: State): State => ({
            ...state,
            error: null,
            loaded: true,
            loading: false,
            receivedTime: luxon.DateTime.now().toISO(),
        })),
        on(actions.load, (state: State): State => ({
            ...state,
            loaded: false,
            loading: true,
        }))
    )
});
